/**
 * State used in rendering CardHeader.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
